// extracted by mini-css-extract-plugin
export default {"root":"KPISwitch_root__+DFXE","label":"KPISwitch_label__+JGTV","switch":"KPISwitch_switch__ywxFx","input":"KPISwitch_input__Wqdfh","slider":"KPISwitch_slider__PXoqf"};